module.exports = __webpack_public_path__ + "static/media/menu-burger.64f4f26b.svg";